import type { IChallenge } from "@bbj-types/challenge";
import type { SocialApplyStatus } from "@bbj-types/socialApply/enum";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { IconButtonVariant } from "@styleguide";
import { useState } from "react";

interface IChallengesMenuProps {
  onConfirm: () => void;
  onCancel: () => void;
  status: SocialApplyStatus;
  matchingChallenges: IChallenge[];
  handleProposeSocialOffer: (status: SocialApplyStatus, selectedChallenges: IChallenge[]) => void;
}

export const ChallengesMenu = ({
  onConfirm,
  onCancel,
  status,
  matchingChallenges,
  handleProposeSocialOffer,
}: IChallengesMenuProps) => {
  const [selectedChallenges, setSelectedChallenges] = useState<IChallenge[]>([]);

  return (
    <Stack
      onClick={(e) => e.stopPropagation()}
      sx={{
        padding: 2,
      }}
    >
      <Typography noWrap>Pour la/les thématique(s):</Typography>
      {matchingChallenges.map((challenge) => (
        <FormControlLabel
          key={challenge._id}
          sx={() => ({
            "& .MuiCheckbox-root": {
              marginLeft: 0,
            },
          })}
          control={
            <Checkbox
              size="xs"
              onChange={(_, checked) => {
                if (checked) {
                  setSelectedChallenges((challenges) => [...challenges, challenge]);
                } else {
                  setSelectedChallenges((challenges) => challenges.filter((c) => c._id !== challenge._id));
                }
              }}
            />
          }
          label={challenge.name}
        />
      ))}
      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "flex-end",
          mt: 1,
          gap: 1,
        }}
      >
        {onCancel && (
          <IconButtonVariant
            variant="elevated"
            onClick={() => {
              setSelectedChallenges([]);
              onCancel();
            }}
          >
            <CloseIcon />
          </IconButtonVariant>
        )}
        <IconButtonVariant
          variant="elevated"
          sx={{ color: "green" }}
          onClick={() => {
            handleProposeSocialOffer(status, selectedChallenges);
            onConfirm();
          }}
        >
          <CheckIcon />
        </IconButtonVariant>
      </Stack>
    </Stack>
  );
};
